import { render, staticRenderFns } from "./AddTutorEarning.vue?vue&type=template&id=13bff1ba&scoped=true"
import script from "./AddTutorEarning.vue?vue&type=script&lang=js"
export * from "./AddTutorEarning.vue?vue&type=script&lang=js"
import style0 from "./AddTutorEarning.vue?vue&type=style&index=0&id=13bff1ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bff1ba",
  null
  
)

export default component.exports